<!-- ParentComponent.vue -->
<template>
    <div class="login-container">
        <!-- 动态背景层 -->
        <div class="background-blobs">
            <div class="blob blob-1"></div>
            <div class="blob blob-2"></div>
            <div class="blob blob-3"></div>
        </div>
        
        <div class="glass-content">
            <transition name="fade" mode="out-in">
                <Login v-if="showLogin" @to-register="switchForm(false)" />
                <Register v-else @to-login="switchForm(true)" />
            </transition>
        </div>
        
        <div class="footer-copyright">
            © 2025 Navigation Pro. Designed by MingChen.
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import Login from './components/login.vue';
import Register from './components/register.vue';

export default defineComponent({
    name: 'IndexLogin',
    components: { Login, Register },
    setup() {
        const showLogin = ref(true);

        const switchForm = (isLogin) => {
            showLogin.value = isLogin;
        };

        return {
            showLogin,
            switchForm
        };
    }
});
</script>

<style scoped>
.login-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

/* 动态背景球 */
.background-blobs {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}

.blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.6;
    animation: float 10s infinite ease-in-out;
}

.blob-1 {
    top: -10%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
    animation-delay: 0s;
}

.blob-2 {
    bottom: -10%;
    right: -10%;
    width: 600px;
    height: 600px;
    background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
    animation-delay: 2s;
}

.blob-3 {
    top: 40%;
    left: 40%;
    width: 400px;
    height: 400px;
    background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%);
    animation-delay: 4s;
    opacity: 0.4;
}

@keyframes float {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
}

.glass-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 480px;
    padding: 20px;
}

.footer-copyright {
    position: absolute;
    bottom: 20px;
    color: #86868b;
    font-size: 12px;
    z-index: 1;
}
</style>
